import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Link from '../../../Core/Link';
import Image from '../../../Core/Image';

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.neutral_1')};
`;

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  padding: 50px 0 60px;

  > h1,
  > h2,
  > h3,
  > h4,
  > h5,
  > h6 {
    text-align: center;
    margin: 0 auto 25px;
    color: ${themeGet('colors.text-secondary')};
    max-width: 1100px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 50px 90px 60px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 70px 0px 90px;

    > h1,
    > h2,
    > h3,
    > h4,
    > h5,
    > h6 {
      margin-bottom: 50px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 70px 45px 90px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    padding: 70px 90px 90px;
  }
`;

export const StyledBottomLink = styled(Link)`
  align-self: center;
  margin-top: 40px;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-top: 55px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: row;

    &.Right {
      flex-direction: row-reverse;
    }
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 583px;
  margin: 0 auto 30px;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 0 60px 0 0;
    min-height: 400px;
  }
`;

// * Styling for the image
export const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: contain;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    position: absolute;
    left: 0;
    top: 0;
  }
`;

// * Wrapper that holds all content (div beside image)
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h1,
  h2,
  h3 {
    font-size: 26px;
    letter-spacing: -0.5px;
    line-height: 38px;
    text-align: center;
    margin-bottom: 35px;
  }

  h1,
  h2,
  h3,
  p {
    /* for IE */
    width: 100%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    h1,
    h2,
    h3 {
      text-align: left;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    min-width: 450px;
    max-width: 620px;
  }
`;

// * Wrapper for achievements and award
export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 35px;
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    justify-content: space-between;
    margin-top: 57px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

// * Wrapper for achievements
export const Achievements = styled.div`
  display: flex;
  flex-direction: column;
`;

// * Each achievement with the colored pill
export const Achievement = styled.div`
  display: flex;
  margin: 13px 0;

  line-height: 30px;

  &:first-of-type {
    ::before {
      border: 2px solid #95c13d;
    }
  }

  &::before {
    content: '';
    display: inline-block;
    background-color: ${({ color }) => color};
    border: 2px solid #ffc900;
    height: 25px;
    min-width: 79px;
    border-radius: 12.5px;
    margin-right: 18px;

    margin-bottom: -6px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &::before {
      width: 96px;
    }
  }
`;

// * Small award in bottom right
export const Award = styled.img`
  margin: 23px 0 0;
  height: 88px;
  align-self: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    align-self: flex-start;
    margin: 2px 0 0;
  }
`;
